import {
    BooleanField,
    CreateButton,
    DataTable,
    List,
    NumberField,
    SearchInput
} from '@/components/admin';
import { Card } from '@/components/ui/card';
import { TopToolbar } from '../../layout/TopToolbar';

const TaxSlabListActions = () => (
    <TopToolbar>
        <CreateButton label="New Tax Slab" />
    </TopToolbar>
);

const filters = [
    <SearchInput key="q" source="name@ilike" alwaysOn />,
];

export const TaxSlabList = () => (
    <List
        title="Tax Slabs"
        actions={<TaxSlabListActions />}
        filters={filters}
        sort={{ field: 'name', order: 'ASC' }}
        className="p-6"
    >
        <Card className="border-none shadow-sm overflow-hidden">
            <DataTable rowClick="edit">
                <DataTable.Col source="name" label="Tax Slab name" className="font-semibold text-foreground" />
                <DataTable.Col label="CGST">
                    <NumberField source="cgst_rate" options={{ minimumFractionDigits: 1, maximumFractionDigits: 2 }} />
                </DataTable.Col>
                <DataTable.Col label="SGST">
                    <NumberField source="sgst_rate" options={{ minimumFractionDigits: 1, maximumFractionDigits: 2 }} />
                </DataTable.Col>
                <DataTable.Col label="IGST">
                    <NumberField source="igst_rate" options={{ minimumFractionDigits: 1, maximumFractionDigits: 2 }} />
                </DataTable.Col>
                <DataTable.Col source="is_active" label="ActiveStatus">
                    <BooleanField source="is_active" />
                </DataTable.Col>
            </DataTable>
        </Card>
    </List>
);
